import { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";

const DISMISS_KEY = "malinois_announcement_dismissed";

// Thin editorial announcement bar sitting above the header.
// Closable per browser session (sessionStorage).
export function AnnouncementBar() {
  const { t, path } = useLang();
  const bar = t.announcement;
  const [visible, setVisible] = useState(() => {
    if (typeof window === "undefined") return true;
    return window.sessionStorage.getItem(DISMISS_KEY) !== "1";
  });

  const dismiss = () => {
    window.sessionStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  if (!visible || !bar) return null;

  return (
    <div
      className="w-full bg-ink text-paper"
      data-testid="announcement-bar"
      role="region"
      aria-label={bar.label}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-2.5 flex items-center justify-center gap-4 relative">
        <p className="font-mono text-[11px] md:text-xs uppercase tracking-[0.15em] text-center">
          {bar.prefix}
          {" "}
          <Link
            to={path("contact")}
            className="text-accent hover:underline underline-offset-4"
            data-testid="announcement-cta-link"
          >
            {bar.cta}
          </Link>
        </p>
        <button
          type="button"
          onClick={dismiss}
          aria-label={bar.close}
          data-testid="announcement-close-button"
          className="absolute right-4 md:right-8 top-1/2 -translate-y-1/2 text-paper/60 hover:text-paper transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
        >
          <X size={14} strokeWidth={1.5} />
        </button>
      </div>
    </div>
  );
}
